var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510.8 104.7",
    style: {
      enableBackground: "new 0 0 510.8 104.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wordmark"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Full_logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.3,66l0.3-34.9H176l-0.3,36.8c-0.3,20.7-12.9,36.9-35.3,36.8c-22.3-0.1-34.6-16.8-34.5-37.5l0.3-36.1h14.4l-0.3,34.7 c-0.1,13.1,6.9,24.7,20,24.8C153.5,90.8,161.1,79.2,161.3,66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,66.8c0.2-20.7,17.1-37.4,37.7-37.2c0,0,0,0,0,0c13.1,0.1,25.3,6.2,31.7,19.1l-12,6.7c-3.7-7.5-11.5-12.2-19.8-12 c-12.6-0.1-23,10.5-23.1,23.5c-0.1,13,10.3,24.1,22.8,24.2c8.3,0.2,16.1-4.4,20-11.8l11.9,6.7c-6.7,13-18.9,18.7-32,18.6 C202.7,104.8,186,87.6,186.1,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,66.7c0.1-20.7,17-37.3,37.7-37.1c0.2,0,0.5,0,0.7,0c21.7,0.1,38.1,16.2,38,37.7l-0.3,35.9h-13.8V90.5 c-5.5,8.7-15,14.2-26.8,14.2C329.1,104.4,314.1,87.5,314.2,66.7z M376.1,67.3c0.1-13.1-10.5-23.8-23.6-23.9 c-13.1-0.1-23.8,10.5-23.9,23.6c-0.1,13.1,10.5,23.8,23.6,23.9C365.3,91,376,80.4,376.1,67.3C376.1,67.3,376.1,67.3,376.1,67.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.6,
    cy: 67.2,
    r: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.9,43.5c-5.9,0.1-11.2,1.4-15.8,4c0,0-0.1,0.1-0.1,0.1c-6.1,3.5-10.2,10.1-10.2,17.1v38.4H268l0-72h13.1v15.4 c2.5-5,5.8-9,9.9-12.1c4.1-3,8.4-4.7,13-4.9c0.9,0,1.7,0,2.3,0c0.6,0,1.1,0,1.6,0.1V43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.1,25.8v5.4h-14.3v12.7h14.3v59.3h14.1V43.8h19.3V31.2h-19.3v-5.3c0-9.2,5.3-13.1,14-12.9c2.6,0,5.3,0.5,7.7,1.5 L449,2.3c-3.8-1.5-7.8-2.3-11.9-2.3C419.6-0.1,410.3,10.9,410.1,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.1,89.1c-3.3,1.7-6.9,2.5-10.6,2.6c-8.5-0.1-13.7-5.7-13.5-15V43.8h19.8V31.2H484v-28h-14.6v28h-13.9v12.7h13.9v33.2 c-0.1,16.2,9.2,27.5,26.9,27.6c5.1,0.1,10.1-1.3,14.5-3.9L508.1,89.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc084c90f1d6a3d7fc3e4f287a3513a2.svg";
export { ForwardRef as ReactComponent };